import { t } from '../i18n/i18n_service.js?v=20260722a';
import { getSingleActiveCoreGroup } from '../objects/group_service.js?v=20260904c';
import {
  CORE_GROUP_WORKFLOW_STATUSES,
  coreGroupWorkflowStatusDefinition,
  normalizeCoreGroupWorkflowStatus
} from '../objects/core_group_workflow_model.mjs?v=20260903a';
import { setStatus } from '../render/plan_renderer.js?v=20260904f';
import { escapeHtml } from '../utils/html_utils.js?v=20260706d';
import {
  activeDrawingSheet,
  activeDrawingSheetCoreGroup,
  setActiveCoreGroupWorkflowStatus
} from './drawing_sheet_service.js?v=20260904c';

function translatedWorkflowStatusLabel(value) {
  const definition = coreGroupWorkflowStatusDefinition(value);
  return t(definition.labelKey, definition.fallbackLabel);
}

function lifecyclePanelIdentity(sheet, group) {
  const sheetId = String(sheet?.id || '').trim();
  const entryId = String(group?.groupTitleEntryId || '').trim();
  return sheetId && entryId ? `${sheetId}:${entryId}` : '';
}

function selectedActiveCoreGroup() {
  const group = getSingleActiveCoreGroup();
  return group?.meta?.lifecycleSelected === false ? null : activeDrawingSheetCoreGroup(group);
}

function workflowStatusOptions(selectedStatus) {
  return CORE_GROUP_WORKFLOW_STATUSES.map(status => `
    <option value="${escapeHtml(status.id)}" ${status.id === selectedStatus ? 'selected' : ''}>
      ${escapeHtml(t(status.labelKey, status.fallbackLabel))}
    </option>
  `).join('');
}

function renderCoreGroupLifecyclePanel(host) {
  if (!host) return false;
  const sheet = activeDrawingSheet();
  const selectedGroup = selectedActiveCoreGroup();
  if (!sheet || !selectedGroup?.groupTitleEntryId) {
    host.innerHTML = '';
    host.hidden = true;
    return false;
  }

  const workflowStatus = normalizeCoreGroupWorkflowStatus(selectedGroup.workflowStatus);
  const expectedIdentity = lifecyclePanelIdentity(sheet, selectedGroup);
  host.hidden = false;
  host.innerHTML = `
    <div class="card core-group-lifecycle-card" data-core-group-workflow-status="${escapeHtml(workflowStatus)}">
      <div class="card-title">${escapeHtml(t('sidebar_rechts.gruppenstatus.titel.karte', 'Gruppenstatus'))}</div>
      <label class="core-group-workflow-field">
        <span>${escapeHtml(t('sidebar_rechts.gruppenstatus.label.status', 'Status'))}</span>
        <span class="core-group-workflow-control">
          <span class="core-group-workflow-swatch" aria-hidden="true"></span>
          <select data-core-group-workflow-select>
            ${workflowStatusOptions(workflowStatus)}
          </select>
        </span>
      </label>
      <div class="small-text note core-group-workflow-note">
        ${escapeHtml(t(
          'sidebar_rechts.gruppenstatus.wert.hinweis',
          'Der Status dient derzeit nur zur Kennzeichnung. Bearbeitungsregeln folgen später.'
        ))}
      </div>
    </div>
  `;

  host.querySelector('[data-core-group-workflow-select]')?.addEventListener('change', event => {
    const currentSheet = activeDrawingSheet();
    const currentGroup = selectedActiveCoreGroup();
    if (lifecyclePanelIdentity(currentSheet, currentGroup) !== expectedIdentity) {
      setStatus(t(
        'sidebar_rechts.gruppenstatus.wert.auswahl_geaendert',
        'Die ausgewählte Gruppe hat sich geändert. Bitte den Status erneut wählen.'
      ));
      renderCoreGroupLifecyclePanel(host);
      return;
    }
    try {
      const nextStatus = setActiveCoreGroupWorkflowStatus(currentGroup, event.currentTarget.value);
      setStatus(`${t('sidebar_rechts.gruppenstatus.label.status', 'Status')}: ${translatedWorkflowStatusLabel(nextStatus)}`);
    } catch (error) {
      console.warn('Gruppenstatus konnte nicht gespeichert werden', error);
      setStatus(t(
        'sidebar_rechts.gruppenstatus.wert.speichern_fehler',
        'Der Gruppenstatus konnte nicht gespeichert werden.'
      ));
      renderCoreGroupLifecyclePanel(host);
    }
  });
  return true;
}

export {
  renderCoreGroupLifecyclePanel,
  translatedWorkflowStatusLabel
};
